/** Deploy-time marketplace navigation — platform UI reads this, not vertical config. */

import { SAAS_HOST_UI } from '@/platform/saas/saasHostUi';

export type MarketplaceNavItem = {
  href: string;
  label: string;
  icon?: string;
};

function vendorModeEnabled(): boolean {
  // Ops / apex saas-host have no marketplace routes — never prefetch /marketplace.
  if (process.env.NEXT_PUBLIC_COMMUNIO_OPS === 'true') return false;
  if (SAAS_HOST_UI) return false;
  const flag = process.env.NEXT_PUBLIC_VENDOR_MODE;
  if (flag === 'false') return false;
  if (flag === 'true') return true;
  // Default on for reference tenants until explicitly disabled.
  return true;
}

function isCommunioProductBuild(): boolean {
  return process.env.NEXT_PUBLIC_COMMUNIO_PRODUCT === 'true';
}

const shop = {
  href: '/marketplace/',
  label: 'Vendor shops',
  icon: 'uil-shop',
} as const satisfies MarketplaceNavItem;

const hauls = { href: '/marketplace/hauls/', label: 'Haul finds', icon: 'uil-search' } as const satisfies MarketplaceNavItem;

export const marketplaceNav = {
  enabled: vendorModeEnabled(),
  sectionLabel: 'Marketplace',
  becomeSellerLabel: 'Become a seller',
  shop,
  rootHref: shop.href,
  /** Paydirt-only — omitted from Communio Social product builds. */
  hauls: isCommunioProductBuild() ? null : hauls,
  orders: { href: '/marketplace/orders/', label: 'Your orders', icon: 'uil-receipt' },
  sell: { href: '/marketplace/sell/', label: 'Seller dashboard', icon: 'uil-store' },
} as const;

export function isMarketplaceShopActive(pathname: string): boolean {
  const base = pathname.replace(/\/$/, '') || '/';
  if (base === '/marketplace') return true;
  return base.startsWith('/marketplace/sellers');
}

export function isMarketplaceHaulsActive(pathname: string): boolean {
  const base = pathname.replace(/\/$/, '') || '/';
  return base === '/marketplace/hauls' || base.startsWith('/marketplace/hauls/');
}

export function isMarketplaceSellActive(pathname: string): boolean {
  const base = pathname.replace(/\/$/, '');
  return base === '/marketplace/sell' || base.startsWith('/marketplace/sell/');
}

export function isMarketplaceOrdersActive(pathname: string): boolean {
  const base = pathname.replace(/\/$/, '');
  return base === '/marketplace/orders' || base.startsWith('/marketplace/orders/');
}

export function isMarketplaceActive(pathname: string): boolean {
  const base = pathname.replace(/\/$/, '') || '/';
  return base === '/marketplace' || base.startsWith('/marketplace/');
}
